import React, { useState }  from 'react';
import Toggler from '../../template/Toggler';
import {useBan} from '../../../hooks/useBan'

const TabItemOneToggler = ({nesting,subTitle, title, eqv, setEqv,setIsOpenAside,isToggle}) => {
    const [isOn, setIsOn] = useState(false)
    const { isBan, clearAllChanges, setIsBan } = useBan()
    console.log('isToggle', isToggle)

    const handleClick = () => {
        if (isBan) {
            setIsBan(true)
            return
        }
        clearAllChanges()
        setEqv(subTitle)
        setIsOpenAside(state => !state) 
    }

    return (
        <div className={`asside_menu_server_tabs_item ${subTitle === eqv ? 'asside_menu_server_tabs_item_active' : ' '} ${nesting ? 'asside_menu_server_tabs_item_active_nesting_before' : ''}`}
        onClick={handleClick}>
            <div 
            className='asside_menu_server_tabs_item_name'>
                <Toggler
                    setIsOn={setIsOn}
                    isOn={isToggle}
                    subTitle={subTitle}
                    eqv={eqv}
                />
                <p>{title}</p>
            </div>
        </div>
    );
};

export default TabItemOneToggler;